$(document).ready(() => {

    let paged = 1;
    let totalPages = Math.round($('.block-publications').data('totalpages'));

    $('.js-publication-filter').change(function(e){
        paged = 1;
        filterPublications($(this), 'filter');
    });

    if ( paged >= totalPages ) {
        $('.js-load-publication').hide();
    }

    $('.section-publications .btn-clear-filter').click(function(e){
        e.preventDefault();
        paged = 1;
        let $form = $(this).parents('form');
        $form.find('select').each(function(){
            $(this).val([]);
        });
        $form.find('select option').each(function(){
            $(this).prop('selected', false);
            $(this).removeAttr('selected');
        });
        $form.find('.amsify-list-item.active').each(function(){
            $(this).removeClass('active');
        });
        $form.find('.list-tags').html('');
        $form[0].reset();
        filterPublications($(this), 'filter');
    });

    $('.form-search-publication').submit(function(e){
        e.preventDefault();
        paged = 1;
        filterPublications($(this), 'filter');
    });

    $(document).on('click', '.js-load-publication', function(e){
        e.preventDefault();
        paged += 1;
        filterPublications($(this), 'load');
    });

    function filterPublications($el, $event){
        let $parent = $el.parents('.section-publications');
        let $numberposts = $parent.data('numberposts');
        let $disciplines = $parent.find('[name="disciplines"]').val();
        let $categories = $parent.find('[name="categories"]').val();
        let $year = $parent.find('[name="year"]').val();
        let $search = $parent.find('[name="search"]').val();
        let publicationsWrapp = $parent.find('.block-publications');

        $('.amsify-selection-area').removeClass('open-list');
        $('.amsify-selection-list').hide();

        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'filter_publications',
                numberposts: $numberposts,
                categories: $categories,
                disciplines: $disciplines,
                year: $year,
                search: $search,
                paged: paged,
            },
            success(data) {
                let newPublications = $(data.content);
                totalPages = Math.round(newPublications.data('totalpages'));
                if ( paged >= totalPages  ) {
                    $parent.find('.js-load-publication').hide();
                }
                else {
                    $parent.find('.js-load-publication').show();
                }

                if ($event == 'load') {
                    publicationsWrapp.append(newPublications.find('.box-card'));
                }
                else {
                    publicationsWrapp.html(newPublications.find('.box-card'));
                }
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

});
